import React from 'react';
import { Link } from 'react-router-dom';

export const SiteFooter = () => (
  <footer className="w-footer" data-testid="site-footer">
    <div className="w-container w-footer-inner">
      <div>
        <p className="w-footer-brand">PBNJ Sprinkler &amp; Backflow</p>
        <p className="w-footer-sub">Sprinkler repair, installs, winterizing &amp; certified backflow — Waxahachie &amp; Greater DFW.</p>
      </div>
      <div className="w-footer-links">
        <Link to="/" data-testid="footer-sprinklers-link">Sprinklers</Link>
        <Link to="/backflow" data-testid="footer-backflow-link">Backflow</Link>
        <Link to="/privacy" data-testid="footer-privacy-link">Privacy Policy</Link>
        <Link to="/terms" data-testid="footer-terms-link">Terms of Service</Link>
      </div>
    </div>
    <p className="w-footer-copy">&copy; {new Date().getFullYear()} PBNJ Backflow Testing. All rights reserved.</p>
  </footer>
);

export default SiteFooter;
